<template>
  <tr
    @click="editAction(item)"
    class="pointer ma-4"
    :class="[item.status > 0 && 'low-op-disabeld']"
  >
    <td class="text-center">
      <img
        class="organization-logo mt-2"
        :src="logoSrc"
        @error="onLogoError"
        alt="organization-logo"
      />
    </td>
    <td>
      {{ item.name }}
    </td>
    <td>
      {{ item.status | convertstatus }}
    </td>
    <td>{{ item.fakeID }}</td>
    <td>
      <v-btn
        x-small
        fab
        outlined
        color="#5B5B7A"
        @click.stop="goToSingleOrganization(item)"
      >
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import { selectedHost } from '@/config'

//Component files
import { convertstatus } from './TableRowItem.js'

export default {
  name: 'TableRowItem',
  data() {
    return {
      selectedHost: selectedHost,
      darkLogoMissing: false,
      lightLogoMissing: false,
    }
  },
  props: {
    item: Object,
    editAction: Function,
  },
  filters: {
    convertstatus,
  },
  watch: {
    isDarkMode: function () {
      this.darkLogoMissing = false
      this.lightLogoMissing = false
    },
  },
  computed: {
    ...mapGetters(['isDarkMode']),
    logoSrc() {
      const url = `${selectedHost}/api/images/${this.item.organizationId}/logo`
      const darkUrl = `${url}?dark=true`
      // the company keeps its own logo: the variant it uploaded is used in both modes
      if (this.isDarkMode) return this.darkLogoMissing ? url : darkUrl
      return this.lightLogoMissing && !this.darkLogoMissing ? darkUrl : url
    },
  },
  methods: {
    goToSingleOrganization(organization) {
      this.$router.push(`hosts/${organization.organizationId}`)
    },
    onLogoError(e) {
      const src = e.target.src || ''
      // ignore errors that are not a real logo request
      if (!src.includes('/api/images')) return
      if (src.includes('dark=true')) this.darkLogoMissing = true
      else this.lightLogoMissing = true
    },
  },
}
</script>

<style scoped src="./TableRowItem.css"></style>
